import './overrides';
import { createTheme, ThemeProvider, useTheme } from '@mui/material/styles';
import { useEffect, useState } from 'react';
import { breadcrumbsStyle } from '../breadcrumbs';
import { buttonStyle } from '../button';
import { checkboxStyle } from '../checkbox';
import { chipStyle } from '../chip';
import { dialogStyle } from '../dialog/style';
import { SIDE_NAV_WIDTH } from '../drawer/nav-drawer';
import { formControlStyle } from '../form-control';
import { textfieldStyle } from '../textfield';
import { tooltipStyle } from '../tooltip';
import { deepMerge } from '../utils';
import { getPaletteColor, usePaletteColor } from './color-utils';
import { FontProvider } from './fonts';
import themes, { DefaultColor, Palette } from './manifest';
import { useThemeType } from './type';
export { Palette, DefaultColor };
export { usePaletteColor, getPaletteColor };
export * from './baseline';
export * from './manifest';
export * from './type';
const DEFAULT_FONT_SIZE = 14;
export const DESKTOP_MEDIA_QUERY = '@media (min-width: 1024px) and (min-height: 864px)';
const defaultThemeOptions = {
    breakpoints: {
        values: {
            xs: 0,
            sm: 480 + SIDE_NAV_WIDTH,
            md: 800 + SIDE_NAV_WIDTH,
            lg: 1280 + SIDE_NAV_WIDTH,
            xl: 1600 + SIDE_NAV_WIDTH
        }
    },
    typography: {
        fontSize: DEFAULT_FONT_SIZE,
        htmlFontSize: DEFAULT_FONT_SIZE
    },
    components: {
        ...buttonStyle,
        ...chipStyle,
        ...textfieldStyle,
        ...formControlStyle,
        ...checkboxStyle,
        ...tooltipStyle,
        ...breadcrumbsStyle,
        ...dialogStyle
    }
};
export function getTheme(type = 'magicline', mode = 'light', localization) {
    const name = (() => {
        switch (type) {
            case 'magicline':
                return 'magic-line';
            case 'perfectgym':
                return mode === 'light'
                    ? 'perfect-gym-next'
                    : 'pgn-light-top-navigation';
            case 'planet-fitness':
                return 'planet-fitness';
            case 'perfectleisure':
                return 'perfect-leisure';
        }
    })();
    const theme = themes[name];
    if (theme.palette) {
        theme.palette.mode = mode;
        theme.palette.components = theme.components;
    }
    return createTheme(deepMerge(defaultThemeOptions, themes[name]), localization ?? {});
}
const defaultTheme = createTheme(defaultThemeOptions);
export function useRubiksTheme(themeOptions) {
    const themeType = useThemeType();
    const { localization, mode, type = themeType } = themeOptions ?? {};
    const [theme, setTheme] = useState(() => type || localization
        ? createTheme(getTheme(type, mode, localization))
        : defaultTheme);
    useEffect(() => {
        setTheme(getTheme(type, mode, localization));
    }, [type, mode, localization]);
    return { FontProvider, ThemeProvider, theme };
}
export function useTypographyToken(token) {
    const theme = useTheme();
    if (!token) {
        return undefined;
    }
    function getValueByPath(obj, path) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-return
        return path.split('.').reduce((acc, part) => {
            if (acc && Object.prototype.hasOwnProperty.call(acc, part)) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                return acc?.[part];
            }
            return undefined;
        }, obj);
    }
    return getValueByPath(theme.palette, token);
}
